import { SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function guardarOpcionRespuestaPregunta(obj) {
    try {
        let creado = { creado: false };
        const { code, body } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/opcion-respuesta-pregunta/guardar-opcion-respuesta-pregunta/",
            {
                headers: getHeaders(),
                method: "POST",
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            creado.creado = true;
            creado.id = body.id;
        }
        return creado;
    } catch (err) {
        console.log("guardarOpcionRespuestaPregunta err");
        console.log(err);
        return { creado: false };
    }
}

export async function deshabilitarOpcionRespuestaPregunta(obj) {
    try {
        let result = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/opcion-respuesta-pregunta/deshabilitar-opcion-respuesta-pregunta/",
            {
                headers: getHeaders(),
                method: "PUT",
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            result = true;
        }
        return result;
    } catch (err) {
        console.log("deshabilitarOpcionRespuestaPregunta err");
        console.log(err);
        return false;
    }
}

export async function restaurarOpcionRespuestaPregunta(obj) {
    try {
        let result = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/opcion-respuesta-pregunta/restaurar-opcion-respuesta-pregunta/",
            {
                headers: getHeaders(),
                method: "PUT",
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            result = true;
        }
        return result;
    } catch (err) {
        console.log("restaurarOpcionRespuestaPregunta err");
        console.log(err);
        return false;
    }
}
